define(["require", "exports", "tslib", "@material-ui/core/TextField", "@material-ui/lab/Autocomplete", "lodash.throttle", "mobx-react", "react", "../../utils/MathUtil", "./HGroup", "./Tooltip", "./VGroup"], function (require, exports, tslib_1, TextField_1, Autocomplete_1, lodash_throttle_1, mobx_react_1, React, MathUtil_1, HGroup_1, Tooltip_1, VGroup_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AutoCompleteField = exports.AutoCompleteDebounceRate = void 0;
    TextField_1 = tslib_1.__importDefault(TextField_1);
    Autocomplete_1 = tslib_1.__importDefault(Autocomplete_1);
    lodash_throttle_1 = tslib_1.__importDefault(lodash_throttle_1);
    React = tslib_1.__importStar(React);
    exports.AutoCompleteDebounceRate = 500;
    exports.AutoCompleteField = (0, mobx_react_1.observer)((props) => {
        const initialValue = props.propertyOwner[props.propertyName];
        const [value, setValue] = React.useState(initialValue !== null && initialValue !== void 0 ? initialValue : "");
        const required = props.propertyOwner[props.propertyName + "Req"] || false;
        const tooltip = props.propertyOwner[props.propertyName + "Tooltip"] || "";
        const error = props.propertyOwner[props.propertyName + "Error"];
        const useTooltip = tooltip && tooltip.length > 50;
        const debounceInputChange = React.useRef(props.onChange ? (0, lodash_throttle_1.default)(props.onChange, exports.AutoCompleteDebounceRate, { leading: false, trailing: true }) : () => null);
        React.useEffect(() => {
            setValue(initialValue);
        }, [initialValue]);
        const onSelectionChange = (value) => {
            var _a;
            (_a = props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, value);
        };
        const onInputChange = (value) => {
            const v = (value || "").trim();
            setValue(value);
            if (v.length > (props.minChars || 0)) {
                debounceInputChange.current(v);
            }
        };
        const { id, disabled, dataSource, hideLabel, dataSourceValueField, canCreate, keyDown } = props;
        const classNames = ["field-autocomplete"];
        if (error || (required && !disabled && (value == undefined || value == null || value == ""))) {
            classNames.unshift("field-required");
        }
        let field;
        let uid = (0, MathUtil_1.random)().toString();
        if (disabled) {
            field = React.createElement(TextField_1.default, { key: id, id: uid, className: classNames.join(" "), disabled: true, value: value !== null && value !== void 0 ? value : "" });
        }
        else {
            field = React.createElement(Autocomplete_1.default, { key: id, id: uid, onKeyDown: keyDown, freeSolo: canCreate, className: classNames.join(" "), inputValue: value !== null && value !== void 0 ? value : "", options: dataSource, getOptionLabel: option => {
                    return (option[dataSourceValueField]);
                }, onInputChange: (e, value) => {
                    onInputChange(value);
                }, onChange: (e, value) => {
                    value && onSelectionChange(value);
                }, renderInput: params => {
                    return React.createElement(TextField_1.default, Object.assign({}, params, { inputProps: Object.assign(Object.assign({}, params.inputProps), { autoComplete: uid }) }));
                } });
        }
        if (!hideLabel) {
            return React.createElement(HGroup_1.HGroup, { className: "form-field" },
                React.createElement("span", { className: "label" }, id),
                React.createElement(VGroup_1.VGroup, { style: { flexGrow: 1 } },
                    field,
                    error && (React.createElement("div", { className: "field-error-label" }, error))),
                useTooltip
                    ? React.createElement(Tooltip_1.Tooltip, { text: tooltip, style: { alignItems: "flex-start" } })
                    : null);
        }
        else {
            return field;
        }
    });
});
